

import { humanReadableDate } from '~common-filters/humanReadableDate';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Device, TransferSourceItem, TransformedMigrationData } from '~/interfaces/device.interface';
import { DevicesModule } from '~/store/modules/devices';
interface TextPart { text: string, class?: string }
type TextParts = TextPart[];

@Component
export default class OperationImportDataPopup extends Vue {
    @Prop() migrationData!: TransformedMigrationData;
    @Prop() sourceType!: 'gateway' | 'module';

    get itemKey(): 'bridge_id' | 'module_id' {
        return this.sourceType === 'gateway' ? 'bridge_id' : 'module_id';
    }

    get selectedSource(): TransferSourceItem | null {
        return this.migrationData.selectedSource;
    }

    set selectedSource(data: TransferSourceItem | null) {
        this.$emit('set-selected-source', data);
    }

    getDeviceById(deviceId: string, bridgeId?: string): Device {
        return DevicesModule.getDeviceById(deviceId, bridgeId) || {} as Device;
    }

    textParts(item: Partial<TransferSourceItem>, isSource = true): TextParts {
        return this.sourceType === 'gateway' ? this.gatewayTextParts(item) : this.moduleTextParts(item, isSource);
    }

    gatewayTextParts(item: Partial<TransferSourceItem>): TextParts {
        const textParts: TextParts = [];
        let device: Device = {} as Device;
        if (item.bridge_id) {
            device = this.getDeviceById(item.bridge_id);
        }

        textParts.push(
            this.idTextPart(item.bridge_id || device.id, 'primary'),
            {
                text: `- ${device.name || 'No name'}`,
                class: device.name ? 'text-subtitle-1' : 'font-weight-light',
            },
        );
        return textParts;
    }

    moduleTextParts(item: Partial<TransferSourceItem>, isSource: boolean): TextParts {
        let device: Device = {} as Device;
        if (item.module_id) {
            device = this.getDeviceById(item.module_id, item.bridge_id);
        }

        const textParts: TextParts = [
            this.idTextPart(item.module_id || device.id, 'blue'),
            this.nameTextPart(device.name),
        ];

        if (isSource) {
            textParts.push(
                { text: `(${item.bridge_id})`, class: 'caption monospace primary--text' },
                {
                    text: `- last data: ${humanReadableDate(device.last_data, 'full')}`,
                    class: 'caption monospace'
                },
            );
        }

        return textParts;
    }

    idTextPart(id: string, color: string): TextPart {
        return { text: id, class: `text-subtitle-1 monospace ${color}--text` };
    }

    nameTextPart(name: string): TextPart {
        return {
            text: `- ${name || 'No name'}`,
            class: name ? 'text-subtitle-1' : 'font-weight-light',
        };
    }

}
